import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const LocationIconV2 = (props: SvgProps) => (
  <Svg
    width={35}
    height={43}
    fill="none"
    {...props}
  >
    <Path
      fill="#0058AD"
      fillRule="evenodd"
      d="M32.8 26a17.421 17.421 0 0 0 2.2-8.5C35 7.835 27.165 0 17.5 0S0 7.835 0 17.5c0 3.085.798 5.983 2.2 8.5 2.377 4.272 10.66 12.51 13.943 15.697a1.938 1.938 0 0 0 2.714 0C22.14 38.51 30.423 30.272 32.8 26Zm-15.3-3a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13Z"
      clipRule="evenodd"
    />
  </Svg>
);
export default LocationIconV2;
